import { useState } from 'react';
import { IconUserCheck } from '@iwoca/icons';
import { Card, Input } from '@iwoca/orion';
import clsx from 'clsx';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { InfoCard } from 'components/InfoCard/InfoCard';
import { HelpModal } from 'components/Navigation/Help/HelpModal';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useFormContext } from 'react-hook-form';
import { PRIVACY_FIELD_CLASS } from 'utils/privacyClasses';
import { Guarantors } from '../Guarantors/Guarantors';
import { useSignupData } from '../hooks/useSignupData';
import { PersonalDetails } from '../PersonalDetails/PersonalDetails';
import signupFormStyles from '../SignupForm/SignupForm.module.css';
import { TSignupFormData } from '../SignupForm/SignupForm.types';

import styles from './ClientDetails.module.css';

export const ClientDetails = () => {
  const { stateData, isReintroduction } = useSignupData();
  const [showHelpModal, setShowHelpModal] = useState(false);
  const {
    register,
    formState: { errors },
  } = useFormContext<TSignupFormData>();

  const { checkIntroducerPermission } = useIntroducerData();
  const isDisabled = !checkIntroducerPermission('can_create_applications');

  return (
    <Card className={signupFormStyles.formSection}>
      <h2 className={clsx({ [styles.reintroductionTitle]: isReintroduction })}>
        Applicant details
      </h2>

      {isReintroduction && (
        <InfoCard icon={IconUserCheck} className={styles.reintroductionCard}>
          We’ve pre-filled some details from our records that cannot be edited.
          If anything needs updating, please{' '}
          <ButtonLink
            onClick={() => setShowHelpModal(true)}
            className={styles.contactButton}
            inline
          >
            contact us.
          </ButtonLink>
        </InfoCard>
      )}

      {/* Introducers coming through the API might have missed this information off,
      if they come through step 0 they won't see this */}
      {(!stateData.companyNumber || !stateData.companyNumber) && (
        <div className={styles.nameContainer}>
          <Input
            {...register(`applicant.firstName`)}
            type="text"
            label="First name"
            wrapperClassName={clsx(styles.nameField, PRIVACY_FIELD_CLASS)}
            error={errors?.applicant?.firstName?.message}
            disabled={isDisabled}
          />
          <Input
            {...register(`applicant.lastName`)}
            type="text"
            label="Last name"
            wrapperClassName={clsx(styles.nameField, PRIVACY_FIELD_CLASS)}
            error={errors?.applicant?.lastName?.message}
            disabled={isDisabled}
          />
        </div>
      )}
      {/* eslint-disable-next-line jsx-a11y/aria-role */}
      <PersonalDetails role="applicant" />
      <Guarantors />

      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </Card>
  );
};
